import {
  inGamecenter,
  getGemHost,
  isVkPlay,
  isAstrum,
  isGem,
} from '@vkplay/shared';
import { changeCookieLanguage, isReadMode } from '../../utils/services';
import api from '../../utils/api';

const API_HOST = getGemHost('api');

export default {
  name: 'AppHeader',

  data() {
    return {
      supported_langs: (isVkPlay || isAstrum) ? ['en_US', 'ru_RU'] : ['en_US', 'de_DE', 'fr_FR', 'es_ES', 'pl_PL', 'ru_RU', 'tr_TR', 'ar_AA', 'zh_CN', 'zh_TW', 'pt_BR', 'ko_KR', 'ja_JP'],
    };
  },

  computed: {
    toolbarList() {
      if (isAstrum) {
        return [];
      }

      if (isVkPlay) {
        return [
          {
            type: 'button',
            href: '/',
            text: this.$i18n.t('header.docs'),
            current: window.location.pathname !== '/contacts',
            id: 'docs',
          },
          {
            type: 'button',
            href: '/contacts',
            text: this.$i18n.t('header.contacts'),
            current: window.location.pathname === '/contacts',
            id: 'contacts',
          },
        ];
      }

      return [
        {
          type: 'button',
          href: 'https://developers.my.games',
          text: this.$i18n.t('header.platform'),
          current: false,
          id: 'platform',
        },
        {
          type: 'button',
          href: '/',
          text: this.$i18n.t('header.docs'),
          current: window.location.pathname !== '/contacts',
          id: 'docs',
        },
        {
          type: 'button',
          href: '/contacts',
          text: this.$i18n.t('header.contacts'),
          current: window.location.pathname === '/contacts',
          id: 'contacts',
        },
        {
          type: 'button',
          href: 'https://developers.my.games/dev/login/',
          text: this.$i18n.t('header.developers'),
          current: false,
          id: 'developers',
        },
        {
          type: 'button',
          href: 'https://store.my.games/blog/developers/',
          text: this.$i18n.t('header.blog'),
          current: false,
          id: 'blog',
        },
      ];
    },
  },

  watch: {
    '$root.$i18n.locale': {
      handler: 'renderToolbarList',
    },
  },

  methods: {
    onGetLanguage(lang) {
      changeCookieLanguage(lang);

      window.__GEMS.onGetLang = null;

      this.renderToolbarList();
    },

    renderToolbarList() {
      window.__GEMS.toolbar = {
        align: 'left',
        items: this.toolbarList,
      };
      window.__GEM.renderHeader();
    },

    initHeader(response) {
      let lang = response?.data?.locale;
      const cookieLang = $cookies.get('amc_lang');

      if (cookieLang) {
        lang = cookieLang.slice(0, 2);
      }

      const origin = isVkPlay ? 'https://vkplay.ru' : 'https://store.my.games';

      window.__GEMS = {
        elem: '#js-header',
        client_id: 'platform-core.com',
        continue: 'https://platform-core.com/',
        failure: 'https://platform-core.com/error/',

        langs_available: this.supported_langs,

        signup_birthday: 1,
        signup_subscribe: 1,
        signup_continue: 'https://platform-core.com/after_registration/',
        signup_soc_steam: 0,
        signup_soc_fb: 0,

        no_headline: isAstrum,
        hide_support: true,
        hide_notifications: true,
        hide_chat: true,
        hide_gc: true,
        hide_promo: true,
        enable_analytics: true,
        logo: {
          href: origin,
        },
        lang,
      };


      window.__GEMS.onChangeLang = (lang) => {
        changeCookieLanguage(lang);
        this.$root.$i18n.locale = lang;
      };

      window.__GEMS.onGetLang = lang => this.onGetLanguage(lang);
      window.__GEMS.whenLoaded = () => {
        if (!isAstrum && !isReadMode && !document.getElementById('leelaFooter')) {
          const footerLeela = document.createElement('script');

          footerLeela.id = 'leelaFooter';
          footerLeela.src = `${origin}/hotbox/leela/footer.js`;
          document.body.appendChild(footerLeela);
        }
      };

      if (!isReadMode && !document.getElementById('leelaHeader')) {
        const headerLeela = document.createElement('script');

        headerLeela.id = 'leelaHeader';
        headerLeela.src = `${origin}/hotbox/leela/header.js`;
        document.body.appendChild(headerLeela);
      }
    },
  },

  created() {
    if (inGamecenter || !isGem) {
      window.__GEMS = null;

      if (isAstrum) {
        this.initHeader();
      }

      return;
    }

    api.get(`https://${API_HOST}/social/profile/v2/session`)
      .then((response) => {
        this.initHeader(response);
      })
      .catch(error => console.error(error));
  },
};
